// extracted by mini-css-extract-plugin
export default {"subtitle":"CustomTitle_subtitle__LG9gh","title":"CustomTitle_title__pA-nP"};